import { defaultTo } from 'lodash';
import { DateTime } from 'luxon';
import { IModel, ISalesItemModel, Model, SalesItemModel } from '.';

export interface IClinicSalesItems extends IModel {
  clinicId: number;
  salesDate: string;
  salesItems: ISalesItemModel[];
}

export class ClinicSalesItems
  extends Model
  implements Record<keyof IClinicSalesItems, any>
{
  clinicId: number;
  salesDate: DateTime;
  salesItems: SalesItemModel[];

  constructor(params: Partial<IClinicSalesItems>) {
    super(params);
    this.clinicId = defaultTo(params.clinicId, 0);
    this.salesDate = DateTime.fromISO(
      defaultTo(params.salesDate, '2000-01-01'),
      { zone: 'utc' },
    );
    this.salesItems = (params.salesItems ?? []).map(
      (si) => new SalesItemModel(si),
    );
  }

  filterSalesItemsBySpecies(speciesId: number = 0): SalesItemModel[] {
    if (speciesId === 0) return this.salesItems;
    return _.filter(this.salesItems, function (item) {
      return item.speciesId === speciesId || _.isNil(item.speciesId);
    });
  }
}
